export default {
    seo: {
        home: {
            title: "کد پرو - آموزش برنامه نویسی به روش تعاملی",
            description: "پلتفرم آموزش برنامه نویسی..."
        }
    },

    home: {
        heading: "یادگیری برنامه‌نویسی به سبک تمرین‌محور",
        subtitle: "با تمرین‌های تعاملی...",
        download: "دانلود برنامه اندروید",
        downloadUrl: "https:/"
    }
}